import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from './actionTypes';
import { loginSuccess, apiError } from './actions';

//Include Both Helper File with needed methods
import { login, sessionClear } from '../../apis/auth';
import { isRememberMe } from '../../utils/rememberMe';
import { getMyCompanies } from '../../apis/companies/companies';
import { get, isEmpty } from 'lodash-es';
import { setProfile } from '../profile/actions';
import queryString from "query-string";
import systemAlert from '../../utils/systemAlert';
import { isMobile } from '../../utils/browser';
// import { getStoreCompanies } from '../data/actions';


function* loginUser({ payload: { loginData, history } }) {

  try {
    const userData = yield call(login, {
      id: loginData.id,
      password: loginData.password,
    });
    isRememberMe(loginData.isRemember, loginData.id);

    const myCompanies = yield call(getMyCompanies)
    const companies = get(myCompanies, "data.companies")

    yield put(loginSuccess(userData));

    if (isEmpty(companies)) {
      history.push("/sign-up-complete");
      // history.push("/first-step");
    } else {
      history.push({
        pathname: "/select-company",
        state: { companies },
      });
      if (isMobile()) {
        systemAlert('wecake는 현재, PC Chrom 브라우저에 최적화되어 있어요. wecake APP 또는 PC에서 편리하게 이용해 주세요.')
      }
    }

  } catch (error) {
    yield put(apiError(get(error, 'response.data.message', '알수 없는 오류 관리자에게 문의해주세요.')));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    sessionClear()
    yield put(setProfile(null));
    const query = queryString.parse(history.location.search);
    history.push(`/login${query && query.code ? `?code=${query.code}` : ''}`);
    window.location.reload()
  } catch (error) {
    yield put(apiError(error));
  }
}


export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser)
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser)
}

function* authSaga() {
  yield all([
    fork(watchUserLogin),
    fork(watchUserLogout),
  ]);
}

export default authSaga;